export default [
  {
    path: '/options/list',
    name: 'options',
    meta: {modelName: 'Options', needGuard: true, modules: ['products']},
    component: () => import( '@/modules/modifier-options/Options.vue'),
  },
];
